import * as React from "react";
import GenomeDetailsPage from "../../components/pages/details";
import { NextPageContext } from "next";
import { DarwinPageContext, isServer } from "../../pages/_app";

const GenomeDetails = (props: { uuid: string; tab: string | undefined }) => {
  return <GenomeDetailsPage uuid={props.uuid} tab={props.tab} />;
};

GenomeDetails.getInitialProps = async (ctx: NextPageContext & DarwinPageContext) => {
  const result = { uuid: ctx.query.uuid, tab: ctx.query.tab };
  if (!isServer) {
    return result;
  }

  const { annotationStore, viralVariantStore } = ctx.rootStore;
  await annotationStore.fetchGenomeDetails(ctx.query.uuid as string);
  viralVariantStore.updateFromAnnotationStore(annotationStore);

  return result;
};

export default GenomeDetails;
